module.exports = __webpack_public_path__ + "static/assets/285d87858f213f6a26d076a7b1657850.svg";